import { render, staticRenderFns } from "./RegistrationProcess.vue?vue&type=template&id=5d7dee77&scoped=true&"
import script from "./RegistrationProcess.vue?vue&type=script&lang=js&"
export * from "./RegistrationProcess.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationProcess.vue?vue&type=style&index=0&id=5d7dee77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7dee77",
  null
  
)

export default component.exports